import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ep-tabs" }
const _hoisted_2 = ["onClick", "title"]
const _hoisted_3 = { class: "ep-grid" }
const _hoisted_4 = ["onClick"]

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmojiPicker',
  emits: ["pick"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const open = ref(false)
const wrapEl = ref<HTMLElement | null>(null)
const popupStyle = ref<Record<string, string>>({})

const CATS = [
  { id: 'smileys', icon: '😊', label: 'Rostos' },
  { id: 'hands',   icon: '👍', label: 'Gestos' },
  { id: 'hearts',  icon: '❤️', label: 'Corações' },
  { id: 'objects', icon: '📋', label: 'Objetos' },
  { id: 'symbols', icon: '✅', label: 'Símbolos' },
]

const EMOJIS: Record<string, string[]> = {
  smileys: [
    '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃',
    '😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙',
    '😛','😝','😜','🤪','😎','🥳','😏','😒','😔','😟',
    '🙁','😣','😖','😫','😩','🥺','😢','😭','😤','😠',
    '😡','🤯','😳','🥵','🥶','😱','😨','😰','😓','🤗',
    '🤔','🤭','🫡','😶','😐','😑','😬','🙄','😯','😲',
    '🥱','😴','😷','🤒','🤕','🤢','🤧','🫠','😵','🤐',
  ],
  hands: [
    '👍','👎','👌','🤌','🤙','✌️','🤞','🫰','🤟','🤘',
    '👏','🙌','🤝','🤜','🤛','👊','✊','🫶','🙏','🤲',
    '👐','🫴','🫳','🤚','✋','🖐️','👋','🫱','🫲','💪',
    '🦵','🦶','👂','🦻','👃','🫦','👁️','👀','🫀','🧠',
  ],
  hearts: [
    '❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔',
    '❤️‍🔥','❤️‍🩹','💕','💞','💓','💗','💖','💝','💘','💟',
    '♥️','🫀','💌','💋','💏','💑','👫','👬','👭','🥂',
  ],
  objects: [
    '📱','💻','🖥️','⌨️','🖨️','📧','📞','☎️','📟','📠',
    '📝','📋','📄','📁','🗂️','📅','📆','⏰','⌚','⏱️',
    '🔔','🔕','💡','🔦','🕯️','🪔','🔍','🔎','🔑','🗝️',
    '🔒','🔓','🔨','⚙️','🛠️','💰','💳','📊','📈','📉',
    '🏷️','🎁','🎉','🎊','🎈','🎀','🏆','🥇','⭐','🌟',
  ],
  symbols: [
    '✅','❌','⚠️','🚫','⛔','❓','❗','‼️','⁉️','🔴',
    '🟠','🟡','🟢','🔵','🟣','⚫','⚪','🔺','🔻','▶️',
    '⏩','⏪','⏫','⏬','🔄','🔃','↩️','↪️','🔙','🔚',
    '🔛','🔜','🔝','➡️','⬅️','⬆️','⬇️','↕️','↔️','🔀',
    '💯','🆗','🆕','🆙','🆒','🆓','🆖','🆘','🔞','📵',
    '🕐','🕑','🕒','🕓','🕔','🕕','🕖','🕗','🕘','🕙',
  ],
}

const activeTab = ref('smileys')
const currentEmojis = computed(() => EMOJIS[activeTab.value] ?? [])

function toggle() {
  if (!open.value) {
    open.value = true
    calcPosition()
  } else {
    open.value = false
  }
}

function calcPosition() {
  if (!wrapEl.value) return
  const rect = wrapEl.value.getBoundingClientRect()
  const spaceBelow = window.innerHeight - rect.bottom
  const popupH = 340
  const popupW = 360

  const top = spaceBelow >= popupH
    ? rect.bottom + 4
    : rect.top - popupH - 4
  const left = Math.min(rect.left, window.innerWidth - popupW - 8)

  popupStyle.value = {
    position: 'fixed',
    top: `${top}px`,
    left: `${Math.max(8, left)}px`,
    width: `${popupW}px`,
    zIndex: '99999',
  }
}

function pick(em: string) {
  emit('pick', em)
  open.value = false
}

function onOutsideClick() {
  open.value = false
}

onMounted(() => document.addEventListener('click', onOutsideClick))
onBeforeUnmount(() => document.removeEventListener('click', onOutsideClick))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ep-wrap",
    ref_key: "wrapEl",
    ref: wrapEl
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(["ep-trigger", { 'ep-trigger--open': open.value }]),
      onClick: _withModifiers(toggle, ["stop"]),
      type: "button",
      title: "Emoji"
    }, [...(_cache[1] || (_cache[1] = [
      _createStaticVNode("<svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-ff652cd4><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-ff652cd4></circle><path d=\"M8 14s1.5 2 4 2 4-2 4-2\" data-v-ff652cd4></path><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\" data-v-ff652cd4></line><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\" data-v-ff652cd4></line></svg>", 1)
    ]))], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (open.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "ep-popup",
            style: _normalizeStyle(popupStyle.value),
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(CATS, (cat) => {
                return _createElementVNode("button", {
                  key: cat.id,
                  class: _normalizeClass(["ep-tab", { 'ep-tab--active': activeTab.value === cat.id }]),
                  onClick: ($event: any) => (activeTab.value = cat.id),
                  title: cat.label
                }, _toDisplayString(cat.icon), 11, _hoisted_2)
              }), 64))
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentEmojis.value, (em) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: em,
                  class: "ep-em",
                  onClick: ($event: any) => (pick(em))
                }, _toDisplayString(em), 9, _hoisted_4))
              }), 128))
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}
}

})